import addMinutes from 'date-fns/addMinutes';
import subHours from 'date-fns/subHours';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import parse from 'date-fns/parse';

import Accordion from '../Accordion';

export default class StaticPageStoreLocations {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.weekdays = section.data.weekdays;
    this.store_blocks = section.data.store_blocks;
    this.store_status = section.data.store_status;

    this.$cityDropdown = this.$el.find('#store_locations_cities');
    this.$cityName = this.$el.find('[data-store-locations-city-name]');
    this.$accordionToggle = this.$el.find('[data-accordion-toggle]');
    this.$displayToday = this.$el.find('[data-store-locations-hours-block-id]');

    // NOTE: Subtracted difference from GMT
    this.timeZone = 8;

    this.Accordion = new Accordion(this.$el, {
      activeClass: 'active',
      content: '[data-accordion-content]'
    });

    this.events = [
      this.$accordionToggle.on(
        'click.static-page-store-locations',
        this._toggleHours.bind(this)
      ),
      this.$cityDropdown.on(
        'change.static-page-store-locations',
        this._citySelector.bind(this)
      )
    ];

    this._getToday();
  }

  _citySelector() {
    // Get city name from option value and scroll down to block with same city name ID
    if (this.$cityDropdown.prop('selectedIndex') !== 0) {
      window.location.hash = this.$cityDropdown.val();

      $('html, body').animate(
        {
          scrollTop: $(this.$cityDropdown.val()).offset().top
        },
        500
      );
    }
  }

  _getTimezoneTime(date) {
    const UTCDate = addMinutes(date, date.getTimezoneOffset());
    return subHours(UTCDate, this.timeZone);
  }

  _checkOpenStatus(hoursObj, nowDay) {
    const nowPST = this._getTimezoneTime(new Date());

    const hours = hoursObj[nowDay.toLowerCase()].split(/ - /);
    const openingTime = this._getTimezoneTime(
      parse(hours[0], 'h:mm a', new Date())
    );
    const closingTime = this._getTimezoneTime(
      parse(hours[1], 'h:mm a', new Date())
    );
    return isAfter(nowPST, openingTime) && isBefore(nowPST, closingTime);
  }

  _getToday() {
    const nowDay = this.weekdays[new Date().getDay()];

    // Loop through blocks and display hours for today's day
    $.each(this.store_blocks, (blockId, hoursObj) => {
      const storeStatusText = this.$el.find(
        `[data-store-locations-store-status-block-id=${blockId}]`
      );

      const isOpen = this._checkOpenStatus(hoursObj, nowDay);
      if (isOpen) {
        storeStatusText.text(this.store_status.open).addClass('open');
      } else {
        storeStatusText.text(this.store_status.closed).addClass('closed');
      }

      this.$el
        .find(`[data-store-locations-hours-block-id=${blockId}]`)
        .text(nowDay + ' | ' + hoursObj[nowDay.toLowerCase()]);
    });
  }

  _toggleHours(event) {
    const $target = $(event.currentTarget);
    const $hours = $target.closest('[data-accordion-content]');

    this.Accordion.toggle($hours);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.static-page-store-locations'));
  }
}
